module.exports = __webpack_public_path__ + "static/img/苹果Apple AirPods4降噪版.ae9e054d.png";